import { httpClient } from '@/api/httpClient';
import {
  mapApiResourceToAdminWorkspaceCreation,
  mapApiResourceToWorkspaceRegistration,
  type AdminWorkspaceCreation,
  type AdminWorkspaceCreationApiResource,
  type CreateAdminWorkspacePayload,
  type RegisterWorkspacePayload,
  type WorkspaceRegistration,
  type WorkspaceRegistrationApiResource,
} from './onboardingApi.types';

export async function registerWorkspace(
  payload: RegisterWorkspacePayload
): Promise<WorkspaceRegistration> {
  const response = await httpClient.post<WorkspaceRegistrationApiResource>('/onboarding/register', {
    tenant_type: payload.tenantType,
    workspace_name: payload.workspaceName,
    organization_name: payload.organizationName,
    full_name: payload.fullName,
    email: payload.email,
    password: payload.password,
    phone: payload.phone,
    preferred_language: payload.preferredLanguage,
    accept_terms: payload.acceptTerms,
  });
  return mapApiResourceToWorkspaceRegistration(response.data);
}

export async function createAdminWorkspace(
  payload: CreateAdminWorkspacePayload
): Promise<AdminWorkspaceCreation> {
  const response = await httpClient.post<AdminWorkspaceCreationApiResource>(
    '/onboarding/workspaces',
    {
      tenant_type: payload.tenantType,
      name: payload.name,
      business_name: payload.businessName,
      default_language: payload.defaultLanguage,
      owner_full_name: payload.ownerFullName,
      owner_email: payload.ownerEmail,
    }
  );
  return mapApiResourceToAdminWorkspaceCreation(response.data);
}
